import { ISuccessTicketStatusNew } from '../../../../../../../../types';
import { FieldItem } from '../../ui';
import { ReactComponent as IconSuccess } from '../../../../../../../../assets/images/icons/ic_check_circle.svg';
import './styles.sass';
import { getUITime } from '../../utils/getUITime';
import { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import moment from 'moment';

interface ITicketSuccessStatusNewProps {
    successData: ISuccessTicketStatusNew;
    onClose: () => void;
}

export const TicketSuccessStatusNew = ({ successData, onClose }: ITicketSuccessStatusNewProps) => {
    const elRef = useRef<HTMLDivElement | null>(null);

    const [hasY, setHasY] = useState(false);

    const user = successData?.user;
    const identityDocument = user && successData.user?.identityDocument;

    useEffect(() => {
        const el = elRef.current;
        if (!el) return;

        const measure = () => setHasY(el.scrollHeight > el.clientHeight);

        const ro = new ResizeObserver(measure);
        ro.observe(el);

        measure();

        return () => ro.disconnect();
    }, []);

    const getFormattedAmount = (value: string) => {
        const floatedValue = Number.parseFloat(value);
        if (Number.isNaN(floatedValue)) return '';

        return floatedValue.toLocaleString('ru-RU', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
        });
    };

    const getFormattedDate = (value: string) => {
        const date = moment(value);
        if (!date.isValid()) return '';

        return date.format('DD.MM.YYYY');
    };

    const formattedAmount = successData?.amount ? getFormattedAmount(successData.amount) : '';
    const formattedBirthday = user && user?.birthday ? getFormattedDate(user.birthday) : '';
    const formattedIdentityDocumentDateOfIssue =
        identityDocument && identityDocument?.identityDocumentDateOfIssue
            ? getFormattedDate(identityDocument.identityDocumentDateOfIssue)
            : '';

    return (
        <div className="ticket-status-success-new">
            <div className="ticket-status-success-new__first-row">
                {successData?.activeSinceTime && (
                    <FieldItem
                        label="Время"
                        value={getUITime(successData.activeSinceTime, successData?.activeUntilTime)}
                    />
                )}
                <IconSuccess className="ticket-status-success-new__success-icon" />
            </div>

            <div
                ref={elRef}
                className={cn('ticket-status-success-new__scroll-container', {
                    'ticket-status-success-new__scroll-container--with-scroll': hasY,
                })}
                data-testid="scroll-container"
            >
                <FieldItem label="Мероприятие" value={successData.productName} truncate={{ lines: 2 }} />

                {successData?.tariffName && <FieldItem label="Тариф" value={successData.tariffName} />}

                {successData?.tariffNote && (
                    <FieldItem label="Описание тарифа" value={successData.tariffNote} truncate={{ lines: 2 }} />
                )}

                {formattedAmount && <FieldItem label="Стоимость" value={`${formattedAmount} ₽`} />}

                {user && (
                    <>
                        <FieldItem label="Имя" value={user.fullName} truncate={{ lines: 1 }} />
                        <FieldItem label="Дата рождения" value={formattedBirthday} />

                        {identityDocument && (
                            <>
                                <FieldItem
                                    label="Документ"
                                    value={identityDocument.identityDocumentType}
                                    truncate={{ lines: 1 }}
                                />

                                {(identityDocument?.identityDocumentSeries ||
                                    identityDocument?.identityDocumentNumber) && (
                                    <div className="ticket-status-success-new__series-number-row">
                                        {identityDocument?.identityDocumentSeries && (
                                            <FieldItem label="Серия" value={identityDocument.identityDocumentSeries} />
                                        )}

                                        {identityDocument?.identityDocumentNumber && (
                                            <FieldItem label="Номер" value={identityDocument.identityDocumentNumber} />
                                        )}
                                    </div>
                                )}

                                {formattedIdentityDocumentDateOfIssue && (
                                    <FieldItem label="Дата выдачи" value={formattedIdentityDocumentDateOfIssue} />
                                )}

                                {identityDocument?.identityDocumentIssuedBy && (
                                    <FieldItem
                                        label="Кем выдан"
                                        value={identityDocument.identityDocumentIssuedBy}
                                        truncate={{ lines: 2 }}
                                    />
                                )}

                                {identityDocument?.placeOfBirth && (
                                    <FieldItem label="Место рождения" value={identityDocument.placeOfBirth} />
                                )}
                                {identityDocument?.registrationAddress && (
                                    <FieldItem
                                        label="Адрес регистрации"
                                        value={identityDocument.registrationAddress}
                                        truncate={{ lines: 1 }}
                                    />
                                )}
                            </>
                        )}
                    </>
                )}
            </div>

            <button className="ticket-status-success-new__btn" onClick={onClose}>
                Ок
            </button>
        </div>
    );
};
